<template>
	<div id="navfooter">
		<!--取反的地方在于flag = !flag;-->
		<div id="footer_nav" class="footer_nav" @click="flag = !flag">
			<img src="../../assets/images/navigation.png" />
			<p>导航</p>
		</div>

		<div class="footer_nav_show" v-if="flag">
			<ul class="list">
				<li><!--是 vue-route 中的一个组件，它的作用就是相当于 a 标签一样的给路由做导航，事实上它也确实是默认被渲染为 a 标签。-->
					<router-link to="/menu" tag="p"><!-- shen add加了router-link,字体变颜色-->
						<img src="../../assets/images/menu.png" />
						<p>菜单</p>
					</router-link>
				</li>

				<li>
					<router-link to="/cart"  tag="p"><!-- shen add-->
					    <img src="../../assets/images/cart.png" />
						<p>购物车</p>
					</router-link>
				</li>

				<li>
					<router-link to="/order"  tag="p">
						<img src="../../assets/images/order.png" />
						<p>我的订单</p>
					</router-link>
				</li>

				<li>
					<!--<router-link to ="wallet"  tag="p"> -->
            <!-- 加了router-link后，字体为什么变成了蓝色？ tag="p"的作用是：不用a标签的蓝色，
                 而用p标签的白色，参考官方文档：https://router.vuejs.org/zh/api/#replace -->
						<img src="../../assets/images/wallet.png" />
				    	<p>结账</p>
					<!--</router-link>-->

				</li>

				<li @click="flag = !flag">
					<img src="../../assets/images/close.png" />
					<p>返回</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			flag: false
		};
	}
};
</script>



// WEBPACK FOOTER //
// src/components/public/NavFooter.vue